export default {
    props: {
        text: {
            type: String,
            default: undefined
        },
        action: {
            type: Function,
            default: undefined
        },
        primary: {
            type: Boolean,
            default: undefined
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dialog-vue-wrapper/src/KendoDialog/ActionProps.js